function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h132v132H0z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M132 124c0 4.4-3.6 8-8 8H8c-4.4 0-8-3.6-8-8V8c0-4.4 3.6-8 8-8h116c4.4 0 8 3.6 8 8v116z",
  fill: "#328538"
}), /*#__PURE__*/React.createElement("path", {
  d: "M132 124c0 4.4-3.6 8-8 8H8c-4.4 0-8-3.6-8-8V8c0-4.4 3.6-8 8-8h116c4.4 0 8 3.6 8 8v116z",
  fill: "none",
  vectorEffect: "non-scaling-stroke",
  strokeWidth: 4,
  stroke: "#328538",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M97.787 65.968c0-9.663-7.867-17.524-17.534-17.524h-1.6V54.6h1.6c6.28 0 11.374 5.1 11.374 11.368 0 6.269-5.094 11.369-11.374 11.369h-5.506V39.968H68.6v43.525h11.653c9.667 0 17.534-7.861 17.534-17.525zM64.68 48.444H53.013c-9.653 0-17.52 7.861-17.52 17.524 0 9.664 7.867 17.525 17.52 17.525h1.614v-6.156h-1.614c-6.266 0-11.36-5.1-11.36-11.369 0-6.268 5.094-11.368 11.36-11.368h5.507v37.368h6.16V48.444zM110.667 66c0 24.301-19.694 44-44 44-24.294 0-44-19.699-44-44 0-24.3 19.706-44 44-44 24.306 0 44 19.7 44 44z",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M132 124c0 4.4-3.6 8-8 8H8c-4.4 0-8-3.6-8-8V8c0-4.4 3.6-8 8-8h116c4.4 0 8 3.6 8 8v116z",
  fill: "#308538"
}), /*#__PURE__*/React.createElement("path", {
  d: "M132 124c0 4.4-3.6 8-8 8H8c-4.4 0-8-3.6-8-8V8c0-4.4 3.6-8 8-8h116c4.4 0 8 3.6 8 8v116z",
  fill: "none",
  vectorEffect: "non-scaling-stroke",
  strokeWidth: 4,
  stroke: "#308538",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M97.787 66.634c0-9.662-7.867-17.524-17.534-17.524h-1.6v6.157h1.6c6.28 0 11.374 5.1 11.374 11.367 0 6.27-5.094 11.37-11.374 11.37h-5.506v-37.37H68.6V84.16h11.653c9.667 0 17.534-7.862 17.534-17.526zM64.68 49.11H53.013c-9.653 0-17.52 7.862-17.52 17.524 0 9.664 7.867 17.526 17.52 17.526h1.614v-6.156h-1.614c-6.266 0-11.36-5.1-11.36-11.37 0-6.267 5.094-11.367 11.36-11.367h5.507v37.367h6.16V49.11zm45.987 17.557c0 24.301-19.694 44-44 44-24.294 0-44-19.699-44-44 0-24.3 19.706-44 44-44 24.306 0 44 19.7 44 44z",
  fill: "#FFF"
}));

var SvgQuickbooksLogo = function SvgQuickbooksLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      isolation: "isolate"
    },
    width: 24,
    height: 24,
    viewBox: "0 0 132 132",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgQuickbooksLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/quickbooks-logo.abe51e1c.svg";
export { ForwardRef as ReactComponent };